import styled from "@emotion/styled";

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

const Th = styled.th`
 background-color: ${(props) => props.theme.bgTertiary};
 color: ${(props) => props.theme.textSecondary};
 border: 1px solid${(props) => props.theme.textPrimary};
 padding: 18px;
 text-align: left;
 font-weight: bold;
 @media screen and (max-width:699px){
      padding: 10px;
  }
 @media screen and (max-width:499px){
      padding: 5px;
      font-size: 10px;
  }
 `;

const Td = styled.td`
  border: 1px solid ${(props) => props.theme.textPrimary};
  padding: 18px;
  @media screen and (max-width:699px){
      padding: 10px;
  }
  @media screen and (max-width:499px){
      padding: 5px;
      font-size: 10px;
  }
  `;

const Tr = styled.tr`
text-align: left;
color: ${(props) => props.theme.textPrimary};
  &:nth-child(even) {
    /* background-color: #f2f2f2; */
  }
`;

const StyledTable = () => {
  return (
    <Table data-aos="zoom-in"
    data-aos-easing="ease-in"
    data-aos-delay="300"
    data-aos-offset="0"
    data-aos-duration="1000">
      <thead>
        <Tr>
          <Th></Th>
          <Th>Tokens</Th>
          <Th>Price</Th>
          <Th>%Supply</Th>
          <Th>Rise</Th>
          <Th>Vesting (1St Of Every Month)</Th>
        </Tr>
      </thead>
      <tbody>
        <Tr>
          <Th>Private Round</Th>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>
        <Tr>
          <Th>Public Sale</Th>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>
        <Tr>
          <Th>Marketing/Listing</Th>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>
        <Tr>
          <Th>Liquidity / Adoption Incentives</Th>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>
        <Tr>
          <Th>Team</Th>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>
        <Tr>
          <Th>Advisors</Th>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>
        <Tr>
          <Th>Development</Th>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
          <Td>TBA</Td>
        </Tr>
      
      </tbody>
    </Table>
  );
};

export default StyledTable;
